import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const SmallCard = ({ post }: IProps) => {
	const linkText =
		post.post_type === 'sage_collab_center' ? `View Website` : `View Housing Resources`;
	const target = post.external_url ? `_blank` : `_self`;
	const rel = post.external_url ? `noreferrer noopener` : `noreferrer`;

	return (
		<div className={`pfa-card-wrapper pfa-card-wrapper--${post.post_type}`}>
			<a href={post.permalink} target={target} rel={rel} className="pfa-card-small-card">
				{post.post_title && (
					<h3
						className="pfa-card-small-card__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					/>
				)}
				{post.description && (
					<p className="pfa-card-small-card__description">{post.description}</p>
				)}
				<span className="pfa-card-small-card__link btn-tertiary">{linkText}</span>
			</a>
		</div>
	);
};

SmallCard.displayName = 'SmallCard';

export default SmallCard;
